import { ChangeDetectorRef, Component, Input } from '@angular/core';

@Component({
  selector: 'app-rdsap-ratings',
  templateUrl: './ratings.component.html',
  styleUrls: ['./ratings.component.scss']
})
export class RatingsComponent {
  private _result: any;

  constructor(private cd: ChangeDetectorRef) {}

  @Input()
  set result(value: any) {
    this._result = value;
    this.cd.detectChanges();
  }

  get result(): any {
    return this._result;
  }

  calculateRatingClass(rating: number): string {
    if (rating >= 92) return 'rating-a';
    if (rating >= 81) return 'rating-b';
    if (rating >= 69) return 'rating-c';
    if (rating >= 55) return 'rating-d';
    if (rating >= 39) return 'rating-e';
    if (rating >= 21) return 'rating-f';
    return 'rating-g';
  }

  calculateCurrentClass(current: number): string {
    if (current >= 92) return 'current-a';
    if (current >= 81) return 'current-b';
    if (current >= 69) return 'current-c';
    if (current >= 55) return 'current-d';
    if (current >= 39) return 'current-e';
    if (current >= 21) return 'current-f';
    return 'current-g';
  }

  calculateRatingColor(rating: number): string {
    if (rating >= 92) return '#5bc08b';
    if (rating >= 81) return '#56af62';
    if (rating >= 69) return '#9acb5c';
    if (rating >= 55) return '#fad34b';
    if (rating >= 39) return '#f3ab73';
    if (rating >= 21) return '#e18541';
    return '#FFFFFF';
  }

  calculateEIRatingColor(rating: number): string {
    if (rating >= 92) return '#d2e0f4';
    if (rating >= 81) return '#a3bfe9';
    if (rating >= 69) return '#79a4f7';
    if (rating >= 55) return '#5b82bf';
    if (rating >= 39) return '#a8a7a9';
    if (rating >= 21) return '#686769';
    return '#FFFFFF';
  }

  calculateRatingLetter(rating: number): string {
    if (rating >= 92) return 'A';
    if (rating >= 81) return 'B';
    if (rating >= 69) return 'C';
    if (rating >= 55) return 'D';
    if (rating >= 39) return 'E';
    if (rating >= 21) return 'F';
    return 'G';
  }

  calculateYOffset(rating: number): number {
    const bandHeight = 50;
    if (rating >= 92) return( bandHeight * 0) + 10; // A band
    if (rating >= 81) return bandHeight * 1; // B band
    if (rating >= 69) return bandHeight * 2; // C band
    if (rating >= 55) return bandHeight * 3; // D band
    if (rating >= 39) return bandHeight * 4; // E band
    if (rating >= 21) return bandHeight * 5; // F band
    return bandHeight * 6; // G band
  }

}
